import { FC } from "react";
import { useHorizontalScroll, ScrollDirection } from "@/domains/react/useHorizontalScroll";
import { ScrollButton } from "@/components/horizontal-scroll/ScrollButton";
import {
  HorizontalScrollStyledLeftShadow,
  HorizontalScrollStyledRightShadow,
  HorizontalScrollStyledScrollable,
  HorizontalScrollStyledWrapper,
} from "@/components/horizontal-scroll/horizontal-scroll.styles";
import { HorizontalScrollProps } from "@/components/horizontal-scroll/horizontal-scroll.types";

export const FadeHorizontalScroll: FC<HorizontalScrollProps> = ({
  children,
  className,
  scrollButtonClassName,
  variant = "standard",
  ...props
}) => {
  const {
    scrollContainerRef,
    scrollState,
    handleScroll,
    startScrolling,
    stopScrolling,
    scrollForDuration,
  } = useHorizontalScroll();

  return (
    <HorizontalScrollStyledWrapper>
      <ScrollButton
        direction={ScrollDirection.Left}
        scrollState={scrollState}
        startScrolling={startScrolling}
        stopScrolling={stopScrolling}
        scrollForDuration={scrollForDuration}
        variant={variant}
        scrollButtonClassName={scrollButtonClassName}
      />
      <HorizontalScrollStyledLeftShadow $visible={scrollState.leftVisible} />
      <HorizontalScrollStyledScrollable
        {...props}
        className={className}
        ref={scrollContainerRef}
        onScroll={handleScroll}
      >
        {children}
      </HorizontalScrollStyledScrollable>
      <HorizontalScrollStyledRightShadow $visible={scrollState.rightVisible} />
      <ScrollButton
        direction={ScrollDirection.Right}
        scrollState={scrollState}
        startScrolling={startScrolling}
        stopScrolling={stopScrolling}
        scrollForDuration={scrollForDuration}
        variant={variant}
        scrollButtonClassName={scrollButtonClassName}
      />
    </HorizontalScrollStyledWrapper>
  );
};
